export default function formatTime(time) {
  const sec_num = parseInt(time, 10);
  const hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor((sec_num - hours * 3600) / 60);
  const seconds = sec_num - hours * 3600 - minutes * 60;

  const hoursDisplay = hours > 0 ? `${`0${hours}`.slice(-2)}:` : '';

  return `${hoursDisplay}${`0${minutes}`.slice(-2)}:${`0${seconds}`.slice(-2)}`;
}
